import { NavigationItem } from "types/navigation"
import LinkList from "@modules/layout/components/mega-menu/link-list"
import IconList from "@modules/layout/components/mega-menu/icon-list"
import ImageGrid from "@modules/layout/components/mega-menu/image-grid"
import PromoCards from "@modules/layout/components/mega-menu/promo-cards"

function SectionRenderer({ item }: { item: NavigationItem }) {
  const title = item.label || undefined

  switch (item.display_type) {
    case "icon_list":
      return <IconList items={item.children} title={title} />
    case "image_grid":
      return <ImageGrid items={item.children} title={title} />
    case "promo_cards":
      return <PromoCards items={item.children} title={title} />
    case "link_list":
    default:
      return <LinkList items={item.children} title={title} />
  }
}

export default function MegaMenuPanel({ item }: { item: NavigationItem }) {
  // Separate sections into regular columns and promo cards
  const regularSections = item.children.filter(
    (c) => c.display_type !== "promo_cards"
  )
  const promoSections = item.children.filter(
    (c) => c.display_type === "promo_cards"
  )

  return (
    <div
      className="absolute left-0 right-0 bg-white shadow-xl border-t-2 border-brand-primary z-50"
      role="menu"
      aria-label={`${item.label} submenu`}
    >
      <div className="max-w-screen-2xl mx-auto px-6 py-5">
        <div className="flex gap-6">
          {/* Regular link/icon sections */}
          {regularSections.map((child) => {
            // Sections with many items (icon_list with >8) get more space
            const isWide =
              child.display_type === "icon_list" && child.children.length > 8
            return (
              <div
                key={child.id}
                className={isWide ? "flex-[2] min-w-0" : "flex-1 min-w-0"}
              >
                <SectionRenderer item={child} />
              </div>
            )
          })}

          {/* Promo cards pinned to the right */}
          {promoSections.map((child) => (
            <div key={child.id} className="flex-shrink-0">
              <SectionRenderer item={child} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
